import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { map } from "rxjs/operators";
import { recursosBecas } from "../recursos/interfaz";
import { core } from '@angular/compiler';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class IngresoService {

    constructor(private http: Http, private rutas: recursosBecas, private httpArchivos: HttpClient) { }

    ingresoGestionUsuarios(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionUsuaro', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionRoles(dato1, dato2, dato3, dato4, dato5, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionRol', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionPermisos(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionPermiso', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionBecas(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            param11: dato11,
            param12: dato12,
            param13: dato13,
            param14: dato14,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionBecas', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionRequisitos(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionRequisitos', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionPostulante(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            opc: cual
        });
        // console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionPostulacion', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionPsicologiaE(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionPsicologiaE', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoEncuesta(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionEncuesta', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoSocioEconomico(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, dato15, dato16, dato17, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            param11: dato11,
            param12: dato12,
            param13: dato13,
            param14: dato14,
            param15: dato15,
            param16: dato16,
            param17: dato17,
            opc: cual,
        });
        //console.log("contenido JSON: " + content);
        headers.append("Content-Type", "application/json");
        return this.http.post(this.rutas.rutasPublico + "/ingresoGestionSocioEconomico", content, { headers: headers, }).pipe(map((res) => res.json()));
    }

    ingresoFicha(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, dato15, dato16, dato17, dato18, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            param11: dato11,
            param12: dato12,
            param13: dato13,
            param14: dato14,
            param15: dato15,
            param16: dato16,
            param17: dato17,
            param18: dato18,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/getGetionRespFicha1', content, { headers: headers }).pipe(map(res => res.json()))
    }

    ingresoGestionAjustes(dato1, dato2, dato3, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionAjustes', content, { headers: headers }).pipe(map(res => res.json()))
    }
    ingresoGestionAuditoria(dato1, dato2, dato3, dato4, dato5, dato6, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionAuditoria', content, { headers: headers }).pipe(map(res => res.json()))
    }



    registroGestionFicha(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, dato15, cual) {
        let headers = new Headers();
        var content = JSON.stringify({
            param1: dato1,
            param2: dato2,
            param3: dato3,
            param4: dato4,
            param5: dato5,
            param6: dato6,
            param7: dato7,
            param8: dato8,
            param9: dato9,
            param10: dato10,
            param11: dato11,
            param12: dato12,
            param13: dato13,
            param14: dato14,
            param15: dato15,
            opc: cual
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasPublico + '/ingresoGestionFichaEstudiantil', content, { headers: headers }).pipe(map(res => res.json()))
    }


    envioMail(asunto, recibe, contenido) {
        let headers = new Headers();
        var content = JSON.stringify({
            strAsunto: asunto,
            lstReceptores: [
                {
                    email: recibe
                }
            ],
            lstArchivosAdjuntos: [],
            strCodigoSistema: "SISBECAS",
            strBody: contenido
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasCentralPersona + '/envioCorreo', content, { headers: headers }).pipe(map(res => res.json()))
    }

    medicoIngresoOtrosDatos(opcion, param1, param2, param3, param4) {
        let headers = new Headers();
        var content = JSON.stringify({
            opcion: opcion,
            param1: param1,
            param2: param2,
            param3: param3,
            param4: param4
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasMedico + '/ingresoOtrosDatos', content, { headers: headers }).pipe(map(res => res.json()))
    }

    medicoIngresoReservaCita(historia, fecha, medico, horario, tipo, rol, cargo, dependencia, usuario, rolUser) {
        let headers = new Headers();
        var content = JSON.stringify({
            historia: historia,
            fecha: fecha,
            medico: medico,
            horario: horario,
            tipo: tipo,
            rol: rol,
            cargo: cargo,
            dependencia: dependencia,
            registro: usuario,
            rolRegistro: rolUser
        });
        //console.log("contenido JSON: " + content);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasMedico + '/ingresoReservaCita', content, { headers: headers }).pipe(map(res => res.json()))
    }

    public vecParametro: Array<any>;
    //OBTENER EL REPORTE PDF DEL ESTUDIO SOCIO ECONOMICO
    generPDFBitacora(param1, param2, param3, param4) { 
        let headers = new Headers();
        this.vecParametro = [];
        this.vecParametro.push({
            dato1: param1, dato2: param2, dato3: param3, dato4: param4
        });
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.rutas.rutasReporte + '/repSocioEconomico', this.vecParametro, { headers: headers }).pipe(map(res => res.json()))
    }
    //CARGAR EL ARCHIVO PDF SELECCIONADO
    subirArchivos(contenido: any, token: any): Observable<any> {
        let direccion = this.rutas.rutaGestionArchivos + 'uploadFile/';
        const httpHeaders: HttpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            idAplicacion: this.rutas.idAplicacion,
            jwtsecret: this.rutas.claveAplicacion,
            activo: 'true'
        });
        return this.httpArchivos.post<any>(direccion, contenido, { headers: httpHeaders })
    }
    //OBTENER EL ARCHIVO PDF CARGADO
    mostrarArchivo = (idToken: any, ruta: string) => {
        const vecPDF = {
            ruta: ruta,
            archivo: ruta,
            idAplicacion: this.rutas.idAplicacion,
            idCredencial: 1,
            jwtsecret: this.rutas.claveAplicacion,
            activo: "true"
        }
        return this.httpArchivos.post<any>(this.rutas.rutaGestionArchivos + 'getFile', vecPDF, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + idToken).set('idaplicacion', this.rutas.idAplicacion)
                .set('jwtsecret', this.rutas.claveAplicacion).set('activo', 'true')
        })
    };
    //INVOCAR EL TRANSVERSAL PARA PODER FIRMAR
    FirmarEc(token: any, datos: any): Observable<any> {
        const httpHeaders: HttpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            idAplicacion: this.rutas.idAplicacion,
            jwtsecret: this.rutas.claveAplicacion,
            activo: 'true'
        });
        return this.httpArchivos.post<any>(this.rutas.rutaFirmaWS + 'rutaFirma/firmarDocumentos', datos, { headers: httpHeaders })
    }
    //MUESTRA EL ARCHIVO CARGADO
    obtener64Firmado = (idToken: any) => {
        const httpHeaders: HttpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + idToken,
            idAplicacion: this.rutas.idAplicacion,
            jwtsecret: this.rutas.claveAplicacion,
            activo: 'true'
        });
        const vecPDF = {
            idAplicacion: this.rutas.idAplicacion,
            activo: 'true',
            listado: [{ 'nombre': this.rutas.nombreArchFirma + '.pdf' }]
        }
        return this.httpArchivos.post<any>(this.rutas.rutaFirmaWS + 'rutaFirma/recuperarDocumentos', vecPDF, { headers: httpHeaders })
    }
}
